import * as d3 from 'd3-selection'
import { axisTop as axis } from 'd3-axis'
import * as array from 'd3-array'
import current from '../current-day.js'
import { map } from 'd3-collection'
import timeInterval from '../time-interval.js'

export default function (selection, xScale, formatter, today) {
  selection.each(function (data) {
    var height = this.offsetHeight
      , tickCount = Math.max(Math.abs(xScale.range()[1] / 175), 2) // Number of ticks we can fit
      , [start, stop] = xScale.domain().map(d => d.getTime())
      , time = timeInterval(tickCount, start, stop)
      , ticks = map(time.interval.every(time.step).range(start, stop + 1), date => { // Ticks that should be displayed
                  // Smash duplicate days by creating a map key'd off year-month-day
                  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
                })
                .values()
                .map(date => {
                  // Force time of 00:00:00
                  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
                })

    // At this point the generated ticks all fit within our xScale domain, but we want extend the tick domain so we show an extra tick label at each end,
    // So ticks slide in/out smoothly. See #71
    ticks.unshift(time.interval.offset(ticks[0], -time.step))
    ticks.push(time.interval.offset(ticks[ticks.length - 1], time.step))

    if (today >= xScale.domain()[0] && today <= xScale.domain()[1]) {
      // The current day is inside this viewport, make sure its one of our tick marks
      var override = ticks.reduce((p, c) => Math.abs(c.getTime() - today.getTime()) < Math.abs(p.getTime() - today.getTime()) ? c : p)
        , idx = ticks.indexOf(override)

      ticks[idx] = today

      // Since we're forcing a new tick, let's make sure it's not too close to adjacent ticks
      var todayX = xScale(ticks[idx])
        , prevX = xScale(ticks[idx - 1])
        , nextX = xScale(ticks[idx + 1])
        , threshold = 35

      if (prevX + threshold > todayX - threshold) {
        ticks.splice(idx - 1, 1)
      }

      if (nextX - threshold < todayX + threshold) {
        ticks.splice(idx + 1, 1)
      }
    }

    var _axis = axis().scale(xScale)
                      .tickSize(0)
                      .tickValues(ticks)
                      .tickFormat(formatter)
      , svg = d3.select(this)
                .selectAll('svg')
                .data(function (d) {
                  return [d]
                })
                .enter()
                .append('svg')
                  .attr('width', '100%')
                  .attr('height', '100%')
                  .merge(d3.select(this).selectAll('svg'))
                  .call(current, xScale, height, today)

      svg.selectAll('.gantt-axis')
         .data((d) => [d])
         .enter()
         .append('g')
           .attr('class', 'gantt-axis')
           .merge(svg.selectAll('.gantt-axis'))
            .attr('transform', `translate(0, 30)`)
            .call(_axis)
            .style('font-size', null)
            .style('font-family', null)
            .selectAll('.tick')
            .classed('current-day-tick', d => d == today)
  })
}
